(function ($) {
	class W4D_UserRegistration {
		constructor() {
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.$form = $('#form-register');
			this.$submitBtn = this.$form.find('button[type="submit"]');
			this.sameAddressCheckbox = this.$form.find('.js-same-address-trigger');
			this.sameAddressContainer = $('.js-same-address');
			this.$resendVerification = $('.js-resend-verification');
			this.newsletterCheckbox = this.$form.find('.js-newsletter-checkbox');
		}

		bindEvents() {
			W4D_FrontendHelper.startButtonCountdownUntilEnabled(this.$submitBtn, 9);

			this.$form.validate({
				submitHandler: (form) => {
					if (!W4D_FrontendHelper.checkHoneypot(this.$form)) {
						return;
					}

					this.handleFormSubmit(form);
				},
			});

			this.sameAddressCheckbox.on('change', (e) => this.handleSameAddressToggle(e));
			this.$resendVerification.on('click', (e) => this.handleResendVerification(e));
		}

		handleFormSubmit(form) {
			const fd = new FormData(form);
			const isSameAddress = this.sameAddressCheckbox.prop('checked');
			const newsletterChecked = this.newsletterCheckbox.prop('checked');

			const personalDataFields = ['first-name', 'last-name', 'address', 'city', 'postal-code', 'phone'];
			const personalData = {};
			personalDataFields.forEach((field) => {
				const keyName = field.replace(/-/g, '_');
				personalData[keyName] = fd.get(field)?.trim() || '';
			});

			const ajaxData = {
				action: 'w4d_register_user',
				nonce: w4d_frontend_ajax.nonce,
				data: {
					email: fd.get('email')?.trim(),
					password: fd.get('confirm-password'),
					personalData: personalData,
					usePersonalDataForDelivery: isSameAddress,
					newsletter: newsletterChecked,
				},
			};

			// Only add deliveryData if it's different from personalData
			if (!isSameAddress) {
				const deliveryDataFields = ['same-first-name', 'same-last-name', 'same-address', 'same-city', 'same-postal-code'];
				const deliveryData = {};
				deliveryDataFields.forEach((field) => {
					const keyName = field.replace('same-', '').replace(/-/g, '_');
					deliveryData[keyName] = fd.get(field)?.trim() || '';
				});
				ajaxData.data.deliveryData = deliveryData;
			}

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				success: (response) => {
					if (response.success) {
						window.location.href = response.data.redirect_url;
					} else {
						W4D_Toast.showToast('error', response.data.message);
					}
				},
				error: (xhr, status, error) => {
					console.error('Registration error:', error);
					W4D_Toast.showToast('error', 'Došlo je do pogreške. Pokušajte ponovno.');
				},
			});
		}

		handleSameAddressToggle(e) {
			const isChecked = $(e.target).prop('checked');

			this.sameAddressContainer.css('display', isChecked ? 'none' : 'grid');
		}

		setButtonLoading($button, isLoading) {
			if (isLoading) {
				$button.toggleClass('btn--loading', isLoading);
				$button.prop('disabled', isLoading);
			} else {
				setTimeout(function () {
					$button.toggleClass('btn--loading', isLoading);
					$button.prop('disabled', isLoading);
				}, 2500);
			}
		}

		handleResendVerification(e) {
			e.preventDefault();
			const $btn = $(e.target);
			const tokenId = $btn.data('id');

			if (!tokenId) {
				W4D_Toast.showToast('error', 'Token nedostaje.');
				return;
			}

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: {
					action: 'w4d_resend_verification_email',
					nonce: w4d_frontend_ajax.nonce,
					token: tokenId,
				},
				beforeSend: () => this.setButtonLoading(this.$resendVerification, true),
				success: (response) => {
					if (response.success) {
						W4D_Toast.showToast(
							'success',
							response.data.message || 'Verifikacijski e‑mail je uspješno poslan na vašu e‑mail adresu.'
						);
					} else {
						W4D_Toast.showToast(
							'error',
							response.data.message || 'Došlo je do pogreške pri slanju verifikacijskog e‑maila. Pokušajte ponovno.'
						);
					}
				},
				error: (xhr, status, error) => {
					console.error('Verification resend error:', error);
					W4D_Toast.showToast(
						'error',
						'Nije pronađen token za verifikaciju. Pokušajte se ponovno registrirati ili obratite se administratoru stranice.'
					);
				},
				complete: () => this.setButtonLoading(this.$resendVerification, false),
			});
		}
	}

	$(document).ready(() => {
		new W4D_UserRegistration();
	});
})(jQuery);
